import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AdminLogin from "./pages/AdminLogin";
import MemberLogin from "./pages/MemberLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AccessDenied from "./pages/AccessDenied";
import ProtectedRoute from "./components/ProtectedRoute";
import MemberSignUp from "./pages/MemberSignUp";
import ForgotPassword from "./pages/ForgotPassword";
import CoachLogin from "./pages/CoachLogin";
import CoachDashboard from "./pages/CoachDashboard";
import ClassBooking from "./pages/ClassBooking";
import { ReminderProvider } from "./pages/ReminderContext";
import ReminderWrapper from "./pages/ReminderWrapper";
import './index.css';
import { LogoProvider } from "./pages/LogoContext";
import { SpinLoading } from "antd-mobile";
import { ClassAccordionProvider } from "./pages/ClassAccordionContext";

const MemberDashboard = React.lazy(() => import('./pages/MemberDashboard'));

const App = () => {
  return (
    <AuthProvider>
      <ReminderProvider>
        <LogoProvider>
          <ClassAccordionProvider>
            <ReminderWrapper>
              {/** Use createBrowserRouter + RouterProvider to enable future flags (v7_relativeSplatPath) */}
              <RouterProvider router={createBrowserRouter(
                [
                  { path: "/admin-login", element: <AdminLogin /> },
                  { path: "/coach-login", element: <CoachLogin /> },
                  { path: "/member-login", element: <MemberLogin /> },
                  { path: "/forgot-password", element: <ForgotPassword /> },
                  { path: "/class-booking", element: <ClassBooking /> },
                  { path: "/member-signup", element: <MemberSignUp /> },

                  { path: "/admin-dashboard", element: <ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute> },
                  { path: "/member-dashboard", element: <React.Suspense fallback={<SpinLoading />}><ProtectedRoute requiredRole="member"><MemberDashboard /></ProtectedRoute></React.Suspense> },
                  { path: "/coach-dashboard", element: <ProtectedRoute requiredRole="coach"><CoachDashboard /></ProtectedRoute> },

                  { path: "/access-denied", element: <AccessDenied /> },
                  { path: "/", element: <MemberLogin /> },
                ],
                { future: { v7_relativeSplatPath: true } }
              )}>
              </RouterProvider>
            </ReminderWrapper>
          </ClassAccordionProvider>
        </LogoProvider>
      </ReminderProvider>
    </AuthProvider>
  );
};

export default App;
